ixModuleRouting("impactx.accountassignmenttype", {
    "/accountassignmenttypelist": {
        template: "<ixa-account-assignment-type-list></ixa-account-assignment-type-list>",
        process: "AccountAssignmentType",
        workspace: "admin",
    },
    "/accountassignmenttype/:id": {
        template: "<ixa-account-assignment-type></ixa-account-assignment-type>",
        process: "AccountAssignmentType",
        workspace: "admin",
    },
});
